import axios, { AxiosResponse } from 'axios';
import { IRequestAuth } from '@/modules/Auth/interfaces/request-auth.interface';
import store from '@/store/store';


export class AppError extends Error {
  status: number;
  response: AxiosResponse;

  constructor(m: string, status: number, response: AxiosResponse) {
    super(m);
    Object.setPrototypeOf(this, AppError.prototype);
    this.status = status;
    this.response = response;
  }
}

/*
 interceptor that remove server caching
 */
if (process.env.VUE_APP_USE_HASH_PARAM === '1') {
  axios.interceptors.request.use(config => {
    if (typeof config['disableHashParam'] !== 'undefined') {
      return config;
    }

    config.url += `?t=${+ new Date()}&r=${Math.random()}`;
    return config;
  });
}

/*
 interceptor for set loading for request before get response
 */

axios.interceptors.request.use((config) => {
  store.commit('loadingApp', true);
  return config;
}, (error) => {
  store.commit('loadingApp', false);
  return Promise.reject(error);
});

/*
 interceptor for handle custom error from server and throw it like exception
 */
axios.interceptors.response.use((response: AxiosResponse) => {
  store.commit('loadingApp', false);
  //if get response after send data on Bitrix
  if (response.config.url.indexOf(process.env.VUE_APP_REGISTRATION_ON_BITRIX) !== -1) {
    return response;
  }
  const infinityResponse: Promise<AxiosResponse<any>> = new Promise(() => {});
  const appError = new AppError(response.data.error, response.data.status, response);

  let authErrors = [IRequestAuth.ErrorCode.TokenInvalid, IRequestAuth.ErrorCode.TokenExpired, IRequestAuth.ErrorCode.TokenNotFound];
  if (authErrors.includes(response.data.status)) {
    const auth: any = (store.state as any).auth;
    if (auth.isUser) {
      store.dispatch('auth/sessionErrorResolve');
      /* necessary to break the chain call, because the user will be redirected on authorization page */
      return infinityResponse;
    } else {
      /*
        1. get new token
        2. resend failed request with new token
       */
      const originalRequest: any = response.config;
      if (!originalRequest._retry) {
        originalRequest._retry = true;

        return store.dispatch('auth/resolveError', appError)
          .then(() => {
            const data = JSON.parse(originalRequest.data);
            data.token = auth.token;
            originalRequest.data = JSON.stringify(data);
            return axios(originalRequest);
          });
      }

      throw appError;
    }
  } else if (response.data.status !== undefined && response.data.status !== 200) {
    throw appError;
  }
  return response;
}, (error) => {
  store.commit('loadingApp', false);
  return Promise.reject(error)
});
